import { MessageModel } from "./Message.model";

export class Message extends MessageModel {
    // Add custom methods here
}
